import React, {Component} from 'react';
import {connect} from 'react-redux';
import {retrieveEntityIdFromPermissions} from 'common/utils';
import AddOrgUserForm from './addOrgUserForm';
import REST from 'go/requests/rest';
import _ from 'lodash';

class OrgUserFormContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      orgs: [],
      profile: {
        firstName: '',
        lastName: '',
        companyName: '',
        email: '',
        role: '',
        showRole: false,
      },
      userSubOrgs: [],
    };
  }

  async componentDidMount() {
    const {token, orgId, selectedOrgId, parentOrgId, users} = this.props;

    try {
      this.getSubOrgUser(token, parentOrgId, selectedOrgId, users);
    } catch (err) {
      console.error(err);
    }
  }

  componentDidUpdate(prevProps) {
    const {token, selectedOrgId, parentOrgId, users} = this.props;

    if (users !== prevProps.users) {
      try {
        this.getSubOrgUser(token, parentOrgId, selectedOrgId, users);
      } catch (err) {
        console.error(err);
      }
    }
  }

  componentWillUnmount() {
    this.setState({
      profile: {email: '', role: ''},
    });
  }
  setUserProfile = (firstName, lastName, email, role) => {
    this.setState({
      profile: {
        firstName: firstName,
        lastName: lastName,
        companyName: '',
        email: email,
        role: role,
      },
    });
  };

  getSubOrgUser = (token, orgId, selectedOrgId, users) => {
    REST.user
      .getSubOrgPoc(token, orgId, selectedOrgId)
      .then(REST.handler.handleResponse)
      .then((pocList) => {
        const usersEmails = _.map(users, (user) => user.userId);
        const pocListEmails = _.map(pocList, (poc) => poc.userId);
        const peopleNotInUsers = _.difference(pocListEmails, usersEmails);

        const usersToBeAdded = _.filter(pocList, (user) =>
          _.includes(peopleNotInUsers, user.userId)
        );

        const userSubOrgs = _.map(usersToBeAdded, (user) => {
          return {
            ...user,
            value: user.userId,
            text: `${user.firstName} ${user.lastName} ${user.emailAdr || user.userId}`,
          };
        });

        userSubOrgs.unshift({
          value: '',
          text: '-Select-',
        });

        this.setState({userSubOrgs});
      })
      .catch((error) => console.log(error));
  };

  getSAMUser = (userId) => {
    const {userSubOrgs} = this.state;
    const selectedUser = _.filter(userSubOrgs, (user) => user.userId == userId)[0];
    const profile = {
      email: selectedUser.emailAdr,
      userId: selectedUser.userId,
      isFEMARegistered: true,
      showRole: true,
    };
    this.setState({selectedUser, profile});
  };

  getUser = (email) => {
    const {token, orgId, selectedOrgId, subOrgToggle, userEmailTableToggle} = this.props;
    if (subOrgToggle) {
      REST.user
        .getEntityTeamListByParentId(token, orgId, selectedOrgId)
        .then(REST.handler.handleResponse)
        .then((response) => {
          if (response) {
            const existingEmail = _.map(response, (user, index) => {
              return user.userId;
            });
            if (userEmailTableToggle) {
              REST.user
                .getRegisteredUserByEmail(email)
                .then(REST.handler.handleResponse)
                .then((res) => {
                  this.setState({
                    profile: {
                      searchedEmail: email,
                      email: res.emailAdr,
                      userId: res.userId,
                      firstName: res.firstName,
                      lastName: res.lastName,
                      otherEmails: _.filter(
                        _.map(res.emails, (dto) => dto.emailAdr),
                        (email) => email !== res.emailAdr
                      ),
                      isOrgRegistered: existingEmail.includes(res.userId),
                      isFEMARegistered: !existingEmail.includes(res.userId),
                    },
                  });
                })
                .catch((err) => {
                  this.setState({
                    userNotFound: true,
                  });
                  console.error('err');
                });
            } else if (existingEmail.includes(email)) {
              this.setState({
                profile: {
                  email: email,
                  isOrgRegistered: true,
                },
              });
            } else {
              REST.user
                .getRegisteredUser(token, email)
                .then(REST.handler.handleResponse)
                .then((res) => {
                  this.setState({
                    profile: {
                      email: res.userId,
                      isFEMARegistered: true,
                    },
                  });
                })
                .catch((err) => {
                  this.setState({
                    userNotFound: true,
                  });
                  console.error('err');
                });
            }
          }
        })
        .catch((err) => {
          console.error('err');
        });
    } else {
      REST.user
        .getTeamListByParentId(token, orgId, selectedOrgId)
        .then(REST.handler.handleResponse)
        .then((response) => {
          if (response) {
            const existingEmail = _.map(response, (user, index) => {
              return user.userId;
            });
            if (existingEmail.includes(email)) {
              this.setState({
                profile: {
                  email: email,
                  isOrgRegistered: true,
                },
              });
            } else {
              REST.user
                .getRegisteredUser(token, email)
                .then(REST.handler.handleResponse)
                .then((res) => {
                  this.setState({
                    profile: {
                      email: res.userId,
                      isFEMARegistered: true,
                    },
                  });
                })
                .catch((err) => {
                  this.setState({
                    userNotFound: true,
                  });
                  console.error('err');
                });
            }
          }
        })
        .catch((err) => {
          console.error('err');
        });
    }
  };

  handleRole = (profile) => () => {
    this.props.userEmailTableToggle
      ? this.setState({
          profile: {
            ...profile,
            showRole: true,
          },
        })
      : this.setState({
          profile: {
            showRole: true,
          },
        });
  };

  setEdit = (value) => {
    this.setState({editMode: value});
  };

  resetState = () => {
    this.setState({
      profile: {
        firstName: '',
        lastName: '',
        companyName: '',
        email: '',
        showRole: false,
      },
      userNotFound: false,
    });
  };

  render() {
    const {
      permissions,
      selectedOrgId,
      openModal,
      toggleModal,
      addModalVisible,
      renderMemberInfo,
      getUserData,
      memberInfo,
      reloadUserList,
      subOrgToggle,
      userEmailTableToggle,
      loginGovIntegrationToggle,
      renderType,
      assignedprograms,
      isManuallyAdded,
      orgData,
      displayNameParent,
      parentOrgs,
      orgs,
      programs,
    } = this.props;
    const {loading, profile, userNotFound, editMode, userSubOrgs, selectedUser} =
      this.state;
    return (
      <AddOrgUserForm
        entityId={retrieveEntityIdFromPermissions(permissions)}
        selectedOrgId={selectedOrgId}
        openModal={openModal}
        toggleModal={toggleModal}
        addModalVisible={addModalVisible}
        renderMemberInfo={renderMemberInfo}
        getUserData={getUserData}
        memberInfo={memberInfo}
        reloadUserList={reloadUserList}
        loading={loading}
        userNotFound={userNotFound}
        editMode={editMode}
        setUserProfile={this.setUserProfile}
        createUser={this.createUser}
        getUser={this.getUser}
        getSAMUser={this.getSAMUser}
        profile={profile}
        handleRole={this.handleRole}
        setEdit={this.setEdit}
        token={this.props.token}
        resetState={this.resetState}
        programs={programs}
        subOrgUsers={userSubOrgs}
        subOrgToggle={subOrgToggle}
        userEmailTableToggle={userEmailTableToggle}
        loginGovIntegrationToggle={loginGovIntegrationToggle}
        renderType={renderType}
        assignedprograms={assignedprograms}
        selectedUser={selectedUser}
        isManuallyAdded={isManuallyAdded}
        parentOrgId={this.props.parentOrgId}
        toggles={this.props.toggles}
        orgs={orgs}
        orgData={orgData}
        parentOrgs={parentOrgs}
        displayNameParent={displayNameParent}
      />
    );
  }
}

export const mapStateToProps = (state, ownProps) => {
  return {
    permissions: state.auth.permissions,
    userId: state.auth.userId,
    toggles: state.toggles.toggles,
    orgId: state.userSessionData.orgId,
  };
};

export const connector = connect(mapStateToProps, null);

export default connector(OrgUserFormContainer);
